var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":_vm.linkToDoc}},[_vm._v(_vm._s(this.title))])
}
var staticRenderFns = []

export { render, staticRenderFns }